import React, { useEffect } from 'react';

import { useIntl } from 'react-intl';

import { Box, Text } from '@atlaskit/primitives/compiled';
import {
	type ActionKeys,
	STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY,
} from '@atlassian/conversation-assistant-message-actions-api/constants';
import {
	type ActionRendererFor,
	type ActionRendererKeyToPayload,
	type ActionWith,
} from '@atlassian/conversation-assistant-message-actions-api/types';
import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

import messages from './messages';

export const StudioAutomationTriggerRuleBuildAction = ({
	actions,
}: ActionRendererFor<
	typeof ActionKeys.StudioAutomationTriggerRuleBuild
>): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const firstAction = actions[0];
	const { buildId, succeeded = false } = firstAction.data ?? {};

	useEffect(() => {
		if (!buildId) {
			return;
		}

		window.dispatchEvent(
			new MessageEvent<{ type: string; buildId: string; succeeded: boolean }>('message', {
				data: {
					type: 'studio-automation-build-updated',
					buildId,
					succeeded,
				},
			}),
		);
	}, [buildId, succeeded]);

	if (succeeded) {
		return (
			<Box>
				<Text>{formatMessage(messages.actionMessage)}</Text>
			</Box>
		);
	}

	return null;
};

export const filterStudioAutomationTriggerRuleBuildActions = (
	actions: MessageAction[],
): ActionWith<ActionRendererKeyToPayload[typeof ActionKeys.StudioAutomationTriggerRuleBuild]>[] => {
	const filteredActions = actions.filter((action) => {
		if (action.key !== STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY) {
			throw new Error(`Invalid action key for ${STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY}`);
		}
		return action;
	});
	return filteredActions as ActionWith<
		ActionRendererKeyToPayload[typeof ActionKeys.StudioAutomationTriggerRuleBuild]
	>[];
};
